module.exports = __webpack_public_path__ + "img/a3edi.8aa93bd6.png";